import {TypeCPVClassFNSSimple} from './TypeCPVClassFNSSimple';
export class TypeObjCPVFNSSimple {

	public objetPrincipal: TypeCPVClassFNSSimple;

	constructor() { 
		this.objetPrincipal = new TypeCPVClassFNSSimple();
	}
}
